import { useState, useEffect } from "react";
import { api } from "../../services/apiService";

export function useTelemetrySearch() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);

  const search = async (newFilters = filters) => {
    if (!newFilters) return;

    setLoading(true);
    setFilters(newFilters);

    const res = await api.telemetry.search({
      ...newFilters,
      Page: page,
      PageSize: pageSize
    });

    setData(res.data);
    setTotal(res.total);
    setLoading(false);
  };

  useEffect(() => {
    if (filters) {
      search(filters);
    }
  }, [page]);

  return {
    data,
    total,
    page,
    setPage,
    pageSize,
    loading,
    search
  };
}
